import axios from '../../config/axios.js';
import Alpine from 'alpinejs';

function createKasirSocialMedia() {
  return {
    tab: 'accounts',
    accounts: [],
    posts: [],
    platforms: {},
    syncMethods: {},
    postTypes: {},
    loadingPosts: false,
    syncing: false,
    importing: false,
    saving: false,
    filterPlatform: '',
    importPlatform: 'youtube',
    importUrl: '',
    accountModal: false,
    postModal: false,
    accountForm: {},
    postForm: { platform: 'instagram', title: '', caption: '', permalink: '', thumbnail_url: '' },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.accounts = cfg.accounts || [];
        this.posts = cfg.posts || [];
        this.platforms = cfg.platforms || {};
        this.syncMethods = cfg.syncMethods || {};
        this.postTypes = cfg.postTypes || {};
        const keys = Object.keys(this.platforms);
        if (keys.length) this.importPlatform = keys[0];
      } catch (e) {
        console.error('kasirSocialMedia config', e);
      }
    },

    editAccount(acc) {
      this.accountForm = { ...acc };
      this.accountModal = true;
    },

    async saveAccount() {
      this.saving = true;
      try {
        const { data } = await axios.put(`/api/v1/kasir/social/accounts/${this.accountForm.platform}`, {
          username: this.accountForm.username,
          display_name: this.accountForm.display_name,
          profile_url: this.accountForm.profile_url,
          avatar_url: this.accountForm.avatar_url,
          external_id: this.accountForm.external_id,
          bio: this.accountForm.bio,
          sync_method: this.accountForm.sync_method,
          is_active: this.accountForm.is_active,
        });
        const updated = data.data;
        const idx = this.accounts.findIndex((a) => a.platform === updated.platform);
        if (idx >= 0) this.accounts[idx] = updated;
        this.accountModal = false;
        window.toast?.('Akun sosmed disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async syncAccount(acc) {
      this.syncing = true;
      try {
        const { data } = await axios.post(`/api/v1/kasir/social/accounts/${acc.platform}/sync`);
        window.toast?.(data.message || 'Sinkron berhasil.', 'success');
        await this.refreshAccounts();
        if (this.tab === 'posts') await this.fetchPosts();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal sinkron.', 'error');
      } finally {
        this.syncing = false;
      }
    },

    async syncAll() {
      this.syncing = true;
      try {
        const { data } = await axios.post('/api/v1/kasir/social/accounts/sync-all');
        window.toast?.(data.message || 'Sinkron selesai.', 'success');
        await this.refreshAccounts();
        await this.fetchPosts();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal sinkron.', 'error');
      } finally {
        this.syncing = false;
      }
    },

    async refreshAccounts() {
      const { data } = await axios.get('/api/v1/kasir/social/accounts');
      this.accounts = data.data || [];
    },

    async fetchPosts() {
      this.loadingPosts = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/social/posts', {
          params: { platform: this.filterPlatform, per_page: 24 },
        });
        this.posts = data.data || [];
      } catch (e) {
        window.toast?.('Gagal memuat postingan.', 'error');
      } finally {
        this.loadingPosts = false;
      }
    },

    async importPost() {
      if (!this.importUrl.trim()) {
        window.toast?.('URL wajib diisi.', 'error');
        return;
      }
      this.importing = true;
      try {
        const { data } = await axios.post('/api/v1/kasir/social/posts/import-url', {
          platform: this.importPlatform,
          url: this.importUrl.trim(),
        });
        window.toast?.(data.message || 'Berhasil diimpor.', 'success');
        this.importUrl = '';
        await this.fetchPosts();
        await this.refreshAccounts();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal impor URL.', 'error');
      } finally {
        this.importing = false;
      }
    },

    showPostForm() {
      this.postForm = { platform: this.importPlatform, title: '', caption: '', permalink: '', thumbnail_url: '' };
      this.postModal = true;
    },

    async savePost() {
      if (!this.postForm.permalink?.trim()) {
        window.toast?.('URL postingan wajib diisi.', 'error');
        return;
      }
      this.saving = true;
      try {
        await axios.post('/api/v1/kasir/social/posts', this.postForm);
        window.toast?.('Postingan ditambahkan.', 'success');
        this.postModal = false;
        await this.fetchPosts();
        await this.refreshAccounts();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async removePost(p) {
      const ok = await window.confirmDialog?.({
        title: 'Hapus postingan?',
        message: 'Postingan akan dihapus dari feed publik.',
        confirmText: 'Hapus',
        variant: 'danger',
      });
      if (ok === false) return;
      try {
        await axios.delete(`/api/v1/kasir/social/posts/${p.id}`);
        window.toast?.('Postingan dihapus.', 'success');
        await this.fetchPosts();
        await this.refreshAccounts();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirSocialMedia', createKasirSocialMedia);
